// Module
var code = `<footer class="login-register-footer"><p class="support-link"><span ng-if="brandNameShort" translate-once="authentication.login_register_footer.get_help" translate-values="{brandName: brandNameShort}" translate-compile></span><br><span translate-once="authentication.login_register_footer.simply_signout" translate-compile></span></p></footer>`;
// Exports
export default code;